var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var Loader = (function (_super) {
    __extends(Loader, _super);
    function Loader(props) {
        return _super.call(this, props) || this;
    }
    Loader.prototype.render = function () {
        var _a = this.props, type = _a.type, height = _a.height;
        var divStyle = {
            minHeight: (height || 50) + "px"
        };
        if (type) {
            return (React.createElement("div", { className: "as-absolute loading-spinner " + type, style: divStyle }));
        }
        else {
            return (React.createElement("div", { className: 'loading-spinner', style: divStyle }));
        }
    };
    return Loader;
}(React.Component));
export { Loader };
